import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { UserActions } from '@next/core-lib/user';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { switchMap, map, startWith, finalize } from 'rxjs/operators';

import * as SoilTypeActions from './soil-type.actions';
import { SiteState } from '../../shared/models';

import { SoilTypeApiService } from '../services/soil-type-api.service';

@Injectable()
export class SoilTypeEffects {
  protected readonly store = inject<Store<SiteState>>(Store);
  protected readonly actions$ = inject(Actions);
  protected readonly soilTypeapi = inject(SoilTypeApiService);

  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      switchMap((_) => [SoilTypeActions.getSoilTypes()]),
    ),
  );

  getSoilTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoilTypeActions.getSoilTypes),
      switchMap((_) =>
        this.soilTypeapi.getSoilTypes().pipe(
          map((soilTypes) => SoilTypeActions.setSoilTypes({ soilTypes })),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
